/**
 * Opens a board's drawers from the stage right nav, which lives in the parent
 * stage component. Drawers are referenced as `${name}Drawer`, e.g. filtersDrawer.
 */
export default {
    mounted () {
        this.$bus.$on('project-board:open-drawer', this.openBoardDrawer)
    },

    beforeDestroy () {
        this.$bus.$off('project-board:open-drawer', this.openBoardDrawer)
    },

    methods: {
        openBoardDrawer (name) {
            const drawer = this.$refs[`${name}Drawer`]

            if (drawer) {
                drawer.open()
            }
        }
    }
}
